import { render, staticRenderFns } from "./selectPage.vue?vue&type=template&id=cb224224&scoped=true&"
import script from "./selectPage.vue?vue&type=script&lang=js&"
export * from "./selectPage.vue?vue&type=script&lang=js&"
import style0 from "./selectPage.vue?vue&type=style&index=0&id=cb224224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb224224",
  null
  
)

export default component.exports